import { ApiRequest, ApiRequestNoLoder } from "../../services/api"

export const PostTradinessData = async (data) => {
    return await ApiRequest("POST", "admin/tradiness-notice", data)
}
export const PostScheduledData = async (data) => {
    return await ApiRequest("POST", "admin/scheduled-request", data)
}
export const PostRequestOtp = async (data) => {
    return await ApiRequest("POST", "admin/request-otp", data)
}
export const PostVerifyOtp = async (data) => {
    return await ApiRequest("POST", "admin/verify-otp", data)
}

export const PostUploadDailySalesReportExcel = async (data) => {
    return await ApiRequest("POST", "admin/upload-market-excel", data, {
        "Content-Type": "multipart/form-data",
    })
}
export const PostStartBot = async (data) => {
    return await ApiRequest("POST", "admin/start-bot", data)
}

export const PostStartTacoBellDelaget = async () => {
    return await ApiRequest("POST", "admin/start-delaget-docker", {})
}

export const PostEmailFooter = async (data) => {
    return await ApiRequest("POST", "admin/email-footer", data)
}
